import React, { useState } from 'react';
import {getActivityLogs} from "@app/services/mainService";
import StatusBadge from "@pages/FUtil/StatusBadge";

const ActivityLogViewer = () => {
    const [searchParams, setSearchParams] = useState({
        table_name: '',
        from_date: '',
        to_date: '',
        id_table: '',
        search_text: ''
    });

    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [expandedRows, setExpandedRows] = useState(new Set());

    // Mock data để demo giao diện
    const mockLogs = [
        {
            id_table: "DH001",
            tablename: "don_hang",
            ngay_tao_log: "2024-12-20 14:30:25",
            thao_tac: "UPDATE",
            nguoi_thao_tac: "Nguyễn Văn A",
            madh: "DH001",
            benh_nhan: "Trần Thị B",
            nha_sy: "BS. Nguyễn C",
            ngay_don_hang: "2024-12-20",
            ngay_giao_dukien: "2024-12-25",
            trang_thai: "Đang xử lý",
            loai_don_hang: "Răng sứ",
            khach_hang: "Phòng khám ABC",
            color_list: "Trắng; Vàng nhạt",
            sanpham_info: "ten: Răng sứ - ma: RS001 - don_gia: 500000 - so_luong: 2",
            nhanvien_dieuphoi: "Nguyễn D",
            nhanvien_cadcam: "Trần E"
        },
        {
            id_table: "DH002",
            tablename: "don_hang",
            ngay_tao_log: "2024-12-20 15:45:10",
            thao_tac: "INSERT",
            nguoi_thao_tac: "Lê Văn F",
            madh: "DH002",
            benh_nhan: "Phạm Văn G",
            nha_sy: "BS. Hoàng H",
            ngay_don_hang: "2024-12-20",
            trang_thai: "Mới tạo",
            loai_don_hang: "Implant",
            khach_hang: "Nha khoa XYZ"
        }
    ];

    const tableOptions = [
        { value: 'donhang', label: 'Đơn hàng' },
        { value: 'khachhang', label: 'Khách hàng' },
        { value: 'sanpham', label: 'Sản phẩm' },
        { value: 'nhanvien', label: 'Nhân viên' }
    ];

    const handleSearch = async () => {
        if (!searchParams.table_name) {
            alert('Vui lòng chọn table cần xem log');
            return;
        }
        if (!searchParams.from_date) {
            alert('Vui lòng chọn từ ngày');
            return;
        }
        if (!searchParams.to_date) {
            alert('Vui lòng chọn đến ngày');
            return;
        }

        setLoading(true);
        try {
            // Simulate API call
            setTimeout(async () => {
                const response = await getActivityLogs(searchParams);
                setLogs(response);
                console.log('logs: ', JSON.stringify(logs, null, 2));
                //setLogs(mockLogs);
                setLoading(false);
            }, 1000);
        } catch (error) {
            console.error('Error fetching logs:', error);
            setLoading(false);
        }
    };

    const handleReset = () => {
        setSearchParams({
            table_name: '',
            from_date: '',
            to_date: '',
            id_table: '',
            search_text: ''
        });
        setLogs([]);
    };

    const toggleRowExpansion = (index) => {
        const newExpanded = new Set(expandedRows);
        if (newExpanded.has(index)) {
            newExpanded.delete(index);
        } else {
            newExpanded.add(index);
        }
        setExpandedRows(newExpanded);
    };

    const getActionBadge = (action) => {
        const colors = {
            'create': 'badge-success',
            'edit': 'badge-warning',
            'delete': 'badge-danger'
        };
        return colors[action] || 'badge-secondary';
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        return new Date(dateStr).toLocaleString('vi-VN');
    };

    return (
        <div className="container-fluid p-4">
            <style jsx>{`
        .container-fluid {
          max-width: 100%;
          margin: 0 auto;
        }
        
        .card {
          border: 1px solid #dee2e6;
          border-radius: 0.375rem;
          background-color: #fff;
          box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
          margin-bottom: 1.5rem;
        }
        
        .card-header {
          padding: 0.75rem 1.25rem;
          margin-bottom: 0;
          background-color: #f8f9fa;
          border-bottom: 1px solid #dee2e6;
          border-top-left-radius: calc(0.375rem - 1px);
          border-top-right-radius: calc(0.375rem - 1px);
          font-weight: 600;
        }
        
        .card-body {
          padding: 1.25rem;
        }
        
        .form-row {
          display: flex;
          flex-wrap: wrap;
          margin-right: -5px;
          margin-left: -5px;
        }
        
        .form-group {
          margin-bottom: 1rem;
          padding-right: 5px;
          padding-left: 5px;
        }
        
        .col-md-4 {
          flex: 0 0 33.333333%;
          max-width: 33.333333%;
        }
        
        .col-md-6 {
          flex: 0 0 50%;
          max-width: 50%;
        }
        
        @media (max-width: 768px) {
          .col-md-4, .col-md-6 {
            flex: 0 0 100%;
            max-width: 100%;
          }
        }
        
        .form-label {
          margin-bottom: 0.5rem;
          font-weight: 600;
          color: #495057;
          display: block;
        }
        
        .form-control {
          display: block;
          width: 100%;
          padding: 0.375rem 0.75rem;
          font-size: 1rem;
          font-weight: 400;
          line-height: 1.5;
          color: #495057;
          background-color: #fff;
          border: 1px solid #ced4da;
          border-radius: 0.375rem;
          transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        }
        
        .form-control:focus {
          color: #495057;
          background-color: #fff;
          border-color: #80bdff;
          outline: 0;
          box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
        }
        
        .btn {
          display: inline-block;
          font-weight: 400;
          color: #212529;
          text-align: center;
          vertical-align: middle;
          cursor: pointer;
          background-color: transparent;
          border: 1px solid transparent;
          padding: 0.375rem 0.75rem;
          font-size: 1rem;
          line-height: 1.5;
          border-radius: 0.375rem;
          transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
          margin-right: 0.5rem;
          text-decoration: none;
        }
        
        .btn:hover {
          text-decoration: none;
        }
        
        .btn:disabled {
          opacity: 0.65;
          cursor: not-allowed;
        }
        
        .btn-primary {
          color: #fff;
          background-color: #007bff;
          border-color: #007bff;
        }
        
        .btn-primary:hover {
          color: #fff;
          background-color: #0069d9;
          border-color: #0062cc;
        }
        
        .btn-secondary {
          color: #fff;
          background-color: #6c757d;
          border-color: #6c757d;
        }
        
        .btn-secondary:hover {
          color: #fff;
          background-color: #5a6268;
          border-color: #545b62;
        }
        
        .btn-success {
          color: #fff;
          background-color: #28a745;
          border-color: #28a745;
        }
        
        .btn-success:hover {
          color: #fff;
          background-color: #218838;
          border-color: #1e7e34;
        }
        
        .table {
          width: 100%;
          margin-bottom: 1rem;
          color: #212529;
          border-collapse: collapse;
        }
        
        .table th,
        .table td {
          padding: 0.75rem;
          vertical-align: top;
          border-top: 1px solid #dee2e6;
        }
        
        .table thead th {
          vertical-align: bottom;
          border-bottom: 2px solid #dee2e6;
          background-color: #f8f9fa;
          font-weight: 600;
        }
        
        .table-striped tbody tr:nth-of-type(odd) {
          background-color: rgba(0, 0, 0, 0.05);
        }
        
        .table-hover tbody tr:hover {
          color: #212529;
          background-color: rgba(0, 0, 0, 0.075);
        }
        
        .badge {
          display: inline-block;
          padding: 0.25em 0.4em;
          font-size: 100%;
          font-weight: 700;
          line-height: 1;
          text-align: center;
          white-space: nowrap;
          vertical-align: baseline;
          border-radius: 0.25rem;
        }
        
        .badge-success {
          color: #fff;
          background-color: #28a745;
        }
        
        .badge-warning {
          color: #212529;
          background-color: #ffc107;
        }
        
        .badge-danger {
          color: #fff;
          background-color: #dc3545;
        }
        
        .badge-secondary {
          color: #fff;
          background-color: #6c757d;
        }
        
        .badge-info {
          color: #fff;
          background-color: #17a2b8;
        }
        
        .text-required {
          color: #dc3545;
        }
        
        .btn-link {
          font-weight: 400;
          color: #007bff;
          text-decoration: none;
          background-color: transparent;
          border: 0;
        }
        
        .btn-link:hover {
          color: #0056b3;
          text-decoration: underline;
        }
        
        .table-responsive {
          display: block;
          width: 100%;
          overflow-x: auto;
        }
        
        .detail-row {
          background-color: #f8f9fa;
        }
        
        .detail-content {
          padding: 1rem;
        }
        
        .detail-section {
          background-color: #fff;
          border: 1px solid #dee2e6;
          border-radius: 0.375rem;
          padding: 1rem;
          margin-bottom: 1rem;
        }
        
        .detail-title {
          font-weight: 600;
          margin-bottom: 0.75rem;
          color: #495057;
          border-bottom: 1px solid #dee2e6;
          padding-bottom: 0.5rem;
        }
        
        .detail-item {
          display: flex;
          margin-bottom: 0.5rem;
        }
        
        .detail-label {
          font-weight: 600;
          min-width: 120px;
          color: #6c757d;
        }
        
        .detail-value {
          flex: 1;
          color: #495057;
        }
        
        .empty-state {
          text-align: center;
          padding: 3rem;
          color: #6c757d;
        }
        
        .spinner {
          display: inline-block;
          width: 1rem;
          height: 1rem;
          border: 0.125em solid currentColor;
          border-right-color: transparent;
          border-radius: 50%;
          animation: spinner-border 0.75s linear infinite;
        }
        
        @keyframes spinner-border {
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>

            {/* Filter Section */}
            <div className="card">
                <div className="card-header">
                    🔍 Bộ lọc tìm kiếm
                </div>
                <div className="card-body">
                    <div className="form-row">
                        <div className="form-group col-md-4">
                            <label className="form-label">
                                Bảng dữ liệu <span className="text-required">*</span>
                            </label>
                            <select
                                className="form-control"
                                value={searchParams.table_name}
                                onChange={(e) => setSearchParams({...searchParams, table_name: e.target.value})}
                            >
                                <option value="">Chọn bảng...</option>
                                {tableOptions.map(option => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group col-md-4">
                            <label className="form-label">
                                Từ ngày <span className="text-required">*</span>
                            </label>
                            <input
                                type="datetime-local"
                                className="form-control"
                                value={searchParams.from_date}
                                onChange={(e) => setSearchParams({...searchParams, from_date: e.target.value})}
                            />
                        </div>

                        <div className="form-group col-md-4">
                            <label className="form-label">
                                Đến ngày <span className="text-required">*</span>
                            </label>
                            <input
                                type="datetime-local"
                                className="form-control"
                                value={searchParams.to_date}
                                onChange={(e) => setSearchParams({...searchParams, to_date: e.target.value})}
                            />
                        </div>

                        <div className="form-group col-md-6">
                            <label className="form-label">ID Bảng</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Nhập ID bảng..."
                                value={searchParams.id_table}
                                onChange={(e) => setSearchParams({...searchParams, id_table: e.target.value})}
                            />
                        </div>

                        <div className="form-group col-md-6">
                            <label className="form-label">Tìm kiếm</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Tìm theo mã hoặc ID..."
                                value={searchParams.search_text}
                                onChange={(e) => setSearchParams({...searchParams, search_text: e.target.value})}
                            />
                        </div>
                    </div>

                    <div style={{ marginTop: '1rem' }}>
                        <button
                            onClick={handleSearch}
                            disabled={loading}
                            className="btn btn-primary"
                        >
                            {loading && <span className="spinner"></span>}
                            {loading ? ' Đang tìm...' : '🔍 Tìm kiếm'}
                        </button>
                        <button
                            onClick={handleReset}
                            className="btn btn-secondary"
                        >
                            🔄 Làm mới
                        </button>
                    </div>
                </div>
            </div>

            {/* Results Section */}
            {logs.length > 0 && (
                <div className="card">
                    <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>📋 Kết quả tìm kiếm ({logs.length} bản ghi)</span>
                        <div>
                            <button className="btn btn-success" style={{ marginRight: '0.5rem' }}>
                                📊 Xuất Excel
                            </button>
                            <button onClick={handleSearch} className="btn btn-primary">
                                🔄 Làm mới
                            </button>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th>Thao tác</th>
                                <th>Thời gian</th>
                                <th>Người thực hiện</th>
                                <th>Mã đơn hàng</th>
                                <th>Bệnh nhân</th>
                                <th>Trạng thái</th>
                                <th>Hành động</th>
                            </tr>
                            </thead>
                            <tbody>
                            {logs.map((log, index) => (
                                <React.Fragment key={index}>
                                    <tr>
                                        <td>
                        <span className={`badge ${getActionBadge(log.thao_tac)}`}>
                          {log.thao_tac}
                        </span>
                                        </td>
                                        <td>{formatDate(log.ngay_tao_log)}</td>
                                        <td>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                                <div style={{
                                                    width: '24px',
                                                    height: '24px',
                                                    backgroundColor: '#6c757d',
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: 'white',
                                                    fontSize: '12px',
                                                    fontWeight: 'bold'
                                                }}>
                                                    {log.nguoi_thao_tac?.charAt(0)}
                                                </div>
                                                {log.nguoi_thao_tac}
                                            </div>
                                        </td>
                                        <td style={{ fontFamily: 'monospace', color: '#007bff' }}>
                                            {log.madh || '-'}
                                        </td>
                                        <td>{log.benh_nhan || '-'}</td>
                                        <td>
                                            {log.trang_thai && (
                                                /*<span className="badge badge-info">
                                                    {log.trang_thai}
                                                </span>*/
                                                <StatusBadge status={log.trang_thai} />
                                            )}
                                        </td>
                                        <td>
                                            <button
                                                onClick={() => toggleRowExpansion(index)}
                                                className="btn btn-link"
                                                style={{ padding: '0.25rem 0.5rem', fontSize: '0.875rem' }}
                                            >
                                                👁️ {expandedRows.has(index) ? 'Ẩn' : 'Chi tiết'}
                                            </button>
                                        </td>
                                    </tr>

                                    {expandedRows.has(index) && (
                                        <tr className="detail-row">
                                            <td colSpan="7">
                                                <div className="detail-content">
                                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1rem' }}>
                                                        <div className="detail-section">
                                                            <div className="detail-title">📦 Thông tin đơn hàng</div>
                                                            <div className="detail-item">
                                                                <span className="detail-label">Nha sĩ:</span>
                                                                <span className="detail-value">{log.nha_sy || '-'}</span>
                                                            </div>
                                                            <div className="detail-item">
                                                                <span className="detail-label">Khách hàng:</span>
                                                                <span className="detail-value">{log.khach_hang || '-'}</span>
                                                            </div>
                                                            <div className="detail-item">
                                                                <span className="detail-label">Loại đơn hàng:</span>
                                                                <span className="detail-value">{log.loai_don_hang || '-'}</span>
                                                            </div>
                                                            <div className="detail-item">
                                                                <span className="detail-label">Ngày đơn hàng:</span>
                                                                <span className="detail-value">{log.ngay_don_hang || '-'}</span>
                                                            </div>
                                                            <div className="detail-item">
                                                                <span className="detail-label">Ngày giao dự kiến:</span>
                                                                <span className="detail-value">{log.ngay_giao_dukien || '-'}</span>
                                                            </div>
                                                            <div className="detail-item">
                                                                <span className="detail-label">Màu sắc:</span>
                                                                <span className="detail-value">{log.color_list || '-'}</span>
                                                            </div>
                                                        </div>

                                                        <div className="detail-section">
                                                            <div className="detail-title">👥 Nhân viên thực hiện</div>
                                                            <div className="detail-item">
                                                                <span className="detail-label">Điều phối:</span>
                                                                <span className="detail-value">{log.nhanvien_dieuphoi || '-'}</span>
                                                            </div>
                                                            <div className="detail-item">
                                                                <span className="detail-label">CAD/CAM:</span>
                                                                <span className="detail-value">{log.nhanvien_cadcam || '-'}</span>
                                                            </div>
                                                            <div className="detail-item">
                                                                <span className="detail-label">Cưa đai:</span>
                                                                <span className="detail-value">{log.nhanvien_cuadai || '-'}</span>
                                                            </div>
                                                            <div className="detail-item">
                                                                <span className="detail-label">Sáp:</span>
                                                                <span className="detail-value">{log.nhanvien_sap || '-'}</span>
                                                            </div>
                                                            <div className="detail-item">
                                                                <span className="detail-label">Đắp:</span>
                                                                <span className="detail-value">{log.nhanvien_dap || '-'}</span>
                                                            </div>
                                                            <div className="detail-item">
                                                                <span className="detail-label">Mài:</span>
                                                                <span className="detail-value">{log.nhanvien_mai || '-'}</span>
                                                            </div>
                                                            <div className="detail-item">
                                                                <span className="detail-label">Giao hàng:</span>
                                                                <span className="detail-value">{log.nhanvien_giaohang || '-'}</span>
                                                            </div>
                                                        </div>

                                                        {log.sanpham_info && (
                                                            <div className="detail-section" style={{ gridColumn: '1 / -1' }}>
                                                                <div className="detail-title">🛍️ Thông tin sản phẩm</div>
                                                                <div style={{
                                                                    backgroundColor: '#f8f9fa',
                                                                    padding: '0.75rem',
                                                                    borderRadius: '0.375rem',
                                                                    fontFamily: 'monospace',
                                                                    fontSize: '0.875rem',
                                                                    color: '#495057'
                                                                }}>
                                                                    {log.sanpham_info}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {logs.length === 0 && !loading && (
                <div className="card">
                    <div className="card-body empty-state">
                        <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🔍</div>
                        <h3 style={{ marginBottom: '0.5rem', color: '#6c757d' }}>Chưa có dữ liệu</h3>
                        <p>Vui lòng nhập thông tin tìm kiếm và nhấn "Tìm kiếm"</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ActivityLogViewer;